module.exports = __webpack_public_path__ + "static/media/viagra.e76538ff.png";